import { Component, OnInit, Input, Inject } from '@angular/core';
import { SharedRankingClassifService } from './shared-ranking-classif.service';
import { faCaretDown, faCaretUp, faCircle } from '@fortawesome/free-solid-svg-icons';
import { WINDOW } from '@core/http/window.providers';

@Component({
    selector: 'app-shared-ranking-classif',
    templateUrl: './shared-ranking-classif.component.html',
    styleUrls: ['./shared-ranking-classif.component.scss'],
})
export class SharedRankingClassifComponent implements OnInit {
    /* Paginação */
    perPage: number = 20;
    page: number = 1;
    /**
     * rankingId
     * id do ranking para buscar
     * filtros e classificação
     */
    @Input() rankingId: any;

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any;

    filter: any;
    filterPost: any;
    classif = [];
    columns = [];

    /** loading */
    loading: boolean = false;

    constructor(private rankingService: SharedRankingClassifService, @Inject(WINDOW) public window: Window) {}

    ngOnInit(): void {
        this.rankingList();
    }

    /**
     * onFilterChange(): Ao mudar parãmetro de filtro
     * @param event Objeto com parâmetros selecionados/alterado através do filtro
     */
    onFilterChange(event) {
        //console.log(`%c FILTER: \n`, 'background:salmon;color:#111;');
        //console.log(event);
        this.rankingList(event);
        /**
         * TODO: FAZER REQUISIÇÃO COM FILTRO
         **/
    }

    /**
     * rankingList() - Buscar classificação do filtro de ranking
     */
    rankingList(event: object = null) {
        this.loading = true;

        this.rankingService.getRanking(this.rankingId, event).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        this.filter = response.registers.filters;
        this.columns = response.registers.list.layout.filter((item) => !!item);
        this.classif = response.registers.list.classif;
        this.loading = false;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
        this.filter = null;
        this.columns = null;
        this.classif = null;
        this.loading = false;
    }

    /**
     * Retorna o icone de acordo com o movimento
     * no ranking.
     * @params mudanca: < 0 | 0 | > 0
     */
    getIconByMove(mudanca) {
        let icon;
        const number = Number(mudanca);

        if (number > 0) {
            icon = faCaretUp;
        } else if (number < 0) {
            icon = faCaretDown;
        } else {
            icon = faCircle;
        }
        return icon;
    }

    /**
     * Retonra cor do icone de ranking de acordo
     * com o movimento do tenista no ranking
     */
    getColorByMove(mudanca) {
        let color;
        const number = Number(mudanca);
        if (number > 0) {
            color = '#4caf50';
        } else if (number < 0) {
            color = '#f44336';
        } else {
            color = '#999';
        }
        return color;
    }
}
